export default __webpack_public_path__ + "static/img2-2f1e229b0ea9778b04fa2d4b2c6a3c22.png";